import { createContext } from "react";

// Shared between VoiceProvider (writer) and useVoice (readers). Lives apart
// from the provider component so that file exports only a component.

export type VoicePhase =
  | "idle"
  | "listening"
  | "transcribing"
  | "thinking"
  | "speaking";

export interface VoiceContextValue {
  phase: VoicePhase;
  /** Hands-free loop on/off. */
  handsFree: boolean;
  /** Speak replies to typed questions as well. */
  readAloud: boolean;
  /** Mic input level 0..1 while listening (for the meter). */
  level: number;
  /** Last voice-specific problem, shown inline; cleared on next action. */
  error: string | null;
  supported: boolean;
  startListening: () => void;
  stopListening: () => void;
  toggleHandsFree: () => void;
  toggleReadAloud: () => void;
  /** Send typed text; speaks the answer when readAloud is on. */
  sendText: (text: string) => Promise<void>;
  /** Abort whatever voice is doing right now (recording, playback…). */
  stopAll: () => void;
}

export const VoiceContext = createContext<VoiceContextValue | null>(null);
